import axios from '@axios'

const route = 'system/config_gratuity'

export default {
  namespaced: true,
  state: {
    gratuitiesAvailable: [],

  },
  getters: {
    getGratuitiesAvailable(state) {
      return state.gratuitiesAvailable
    },
  },
  mutations: {
    setGratuitiesAvailable(state, gratuities) {
      state.gratuitiesAvailable = gratuities
    },
  },
  actions: {

    getAll(context) {
      return axios.get(route)
    },

    updateOrCreate(context, configGratuity) {
      return axios.post(route, configGratuity)
    },

  },
}
